module.exports = __webpack_public_path__ + "img/home-img.ba02bcb2.png";